import { render, staticRenderFns } from "./SlpProfile.vue?vue&type=template&id=5444e1be&scoped=true&"
import script from "./SlpProfile.vue?vue&type=script&lang=js&"
export * from "./SlpProfile.vue?vue&type=script&lang=js&"
import style0 from "./SlpProfile.vue?vue&type=style&index=0&id=5444e1be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444e1be",
  null
  
)

export default component.exports